import {
  Box,
  Button,
  Flex,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { FiAlertCircle } from "react-icons/fi";
import moment from "moment";
import { FaCircle } from "react-icons/fa";
import { isMetaProperty } from "typescript";

import { toast } from "react-toastify";
import { useSetRecoilState, useRecoilState } from "recoil";
import { refreshGlobal } from "../../../../atoms/refreshGlobal";
import {
  GRAY,
  GREENMONEDD,
  REDMONEDD,
  VARIANT,
  WHITE,
} from "../../../../constants/colors";
import TitleFlex from "../../vendasDigitadas/defaultComponents/titleFlex";
import {
  CNPJFormater,
  CPFFormater,
} from "../../../../defaultFunctions/formaters";
import { dateForList } from "../../../../constants/dataFormat";
import copy from "copy-to-clipboard";
import { goToVendaBoletoListagem } from "../../../../routes/coordinator";

export default function ModalRevisãoVendaBoleto({
  isOpen,
  setIsOpen,
  objeto,
  response,
}: any) {
  const finalRef = React.useRef(null);
  const navigate = useNavigate();
  const setRefreshGlobal = useSetRecoilState(refreshGlobal);
  const refresh = useRecoilState(refreshGlobal)[0];

  const onClose = () => {
    setIsOpen(false);
    goToVendaBoletoListagem(navigate);
  };

  const autoClose = () => {};

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={autoClose}
        size={"xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader>
            <Flex w={"100%"} justifyContent={"center"}>
              <Text fontWeight={"bold"} color={GREENMONEDD}>
                Venda gerada com sucesso!
              </Text>
            </Flex>
          </ModalHeader>
          <ModalBody>
            <TitleFlex item={"Link para pagamento"} />

            {objeto && response ? (
              <>
                <TitleFlex item={"Dados do Boleto"} />
                <Flex flexDir={"column"} px={4}>
                  <Text fontSize={"16px"} fontWeight={"bold"}>
                    {response ? response.barcode : null}
                  </Text>
                  <Text fontSize={"12px"}>Código de Barras</Text>
                  <Text>
                    Valor de Cobrança:{" "}
                    {objeto.valor
                      ? objeto.valor.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })
                      : "R$ 0,00"}
                  </Text>
                  <Text>
                    {" "}
                    Id da Transação: {response && response.idTransacao}
                  </Text>
                  <Text>
                    Data de Vencimento:{" "}
                    {objeto && moment(objeto.vencimento).format(dateForList)}
                  </Text>
                </Flex>
              </>
            ) : (
              <></>
            )}
            {objeto ? (
              <>
                <TitleFlex item={"Dados do Pagador"} />
                <Flex flexDir={"column"} px={4}>
                  <Text>
                    Nome do Pagador: {objeto ? objeto.nomePagador : null}
                  </Text>
                  <Text>
                    Documento do Pagador:{" "}
                    {objeto.cpfPagador && objeto.cpfPagador.length === 11
                      ? CPFFormater(objeto.cpfPagador)
                      : CNPJFormater(objeto.cpfPagador)}
                  </Text>
                </Flex>
              </>
            ) : (
              <></>
            )}
            {objeto ? (
              <>
                <TitleFlex item={"Endereço de Cobrança"} />
                <Flex flexDir={"column"} px={4}>
                  <Text
                    fontSize={"13px"}
                  >{`${objeto.enderRua}, ${objeto.enderNumero}/${objeto.enderBairro}-${objeto.enderCidade}-${objeto.enderEstado}`}</Text>
                </Flex>
              </>
            ) : (
              <></>
            )}
          </ModalBody>
          <ModalFooter justifyContent={"space-evenly"}>
            <Button background={GRAY} color={"white"} mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button
              bgColor={VARIANT}
              color={WHITE}
              onClick={() => copy(response.barcode ? response.barcode : "")}
            >
              Copiar Código de Barras
            </Button>
            <Flex flexDir={"column"} px={4} alignItems={"center"}>
              <a href={response && response.url} target={"_blank"}>
                <Button color={WHITE} bgColor={VARIANT}>
                  Abrir Boleto
                </Button>
              </a>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
